import { defineSlotRecipe } from "@chakra-ui/react-v3";
import { avatarAnatomy } from "@chakra-ui/react-v3/anatomy";

export const avatarRecipe = defineSlotRecipe({
  slots: avatarAnatomy.keys(),

  base: {
    root: {
      "--avatar-radius": "radii.full",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "medium",
      position: "relative",
      verticalAlign: "top",
      flexShrink: "0",
      userSelect: "none",
      width: "var(--avatar-size)",
      height: "var(--avatar-size)",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)",
      bg: "avatar.charcoal",
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "var(--avatar-radius)",
    },

    fallback: {
      lineHeight: "1",
      textTransform: "uppercase",
      fontWeight: "bold",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)",
      color: "fg.inverted",
      textStyle: "body.12",
    },
  },

  variants: {
    size: {
      xs: {
        root: {
          "--avatar-size": "sizes.5",
          "--avatar-font-size": "fontSizes.xs",
        },
      },
      sm: {
        root: {
          "--avatar-size": "sizes.6",
          "--avatar-font-size": "fontSizes.sm",
        },
      },
      md: {
        root: {
          "--avatar-size": "sizes.10",
          "--avatar-font-size": "fontSizes.md",
        },
        fallback: {
          textStyle: "heading.18",
        },
      },
      lg: {
        root: {
          "--avatar-size": "sizes.20",
          "--avatar-font-size": "fontSizes.md",
        },
        fallback: {
          textStyle: "heading.32",
        },
      },
    },
  },

  defaultVariants: {
    size: "md",
  },
});
